import { useQuery } from '@tanstack/react-query';
import { QueryView } from '@ui/utils/async-view/QueryView';
import { Link } from 'react-router-dom';
import { apiClient } from '../../../api';

export function FragmentLink({ stationId, id }: { stationId: string; id: string }) {
  const query = useQuery({
    queryKey: ['fragment', id],
    queryFn: () => apiClient.fragments.fetch(id),
  });

  return (
    <QueryView inline query={query}>
      {(data) => <Link to={`/fragments/${id}`}>{data.title}</Link>}
    </QueryView>
  );
}
